import React, { Fragment, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaUserMd } from "react-icons/fa";
import { HiOutlineSquares2X2 } from "react-icons/hi2";
import { IoHelpCircleOutline, IoSettingsOutline } from "react-icons/io5";
import utilstopAppointmentLogo from "../../assets/images/EzietPro Logo.svg";
import { SlCalender } from "react-icons/sl";

import * as apicall from "../../components/Apicall";
import { CiUser } from "react-icons/ci";
import { MdOutlineReport } from "react-icons/md";

const Sidebar = ({ isOpen, vendorData }) => {
  const [reports, setReports] = useState([]);
  const [showReport, setShowReport] = useState(false);

  let allServices = JSON.parse(localStorage.getItem("services"));
  const isClinicService = allServices?.some(
    (ele) => ele?.service_name === "Clinical Appointment"
  );

  useEffect(() => {
    getReports();
  }, []);

  async function getReports() {
    try {
      const response = await apicall.get(`get_reports`);
      if (response.status === 200) {
        setReports(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching specializations:", error);
      // toast.error('Failed to fetch specializations');
    }
  }

  // console.log("reports----", reports);

  return (
    <div
      className={`sidebar bg-white border-end ${isOpen ? "open" : ""}`}
      style={{ width: "240px" }}
    >
      <div className="d-flex flex-column justify-content-between h-100 py-3">
        <ul className="nav flex-column">
          <li className="nav-item mb-1">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                  isActive ? "btn-danger text-white" : "text-secondary"
                }`
              }
              style={{ borderRadius: "4px", margin: "0 8px" }}
            >
              <HiOutlineSquares2X2 style={{ fontSize: "18px" }} />
              <span className="form-labels">Dashboard</span>
            </NavLink>
          </li>
          {!isClinicService && (
            <Fragment>
              <li className="nav-item mb-1">
                <NavLink
                  to="/vendor_bookings"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                      isActive ? "btn-danger text-white" : "text-secondary"
                    }`
                  }
                  style={{ borderRadius: "4px", margin: "0 8px" }}
                >
                  <SlCalender style={{ fontSize: "18px" }} />

                  <span className="form-labels">New Booking</span>
                </NavLink>
              </li>
              <li className="nav-item mb-1 ">
                <NavLink
                  to="/providers"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                      isActive ? "btn-danger text-white" : "text-secondary"
                    }`
                  }
                  style={{ borderRadius: "4px", margin: "0 8px" }}
                >
                  {/* <FaUserMd style={{ fontSize: "18px" }} /> */}
                  <CiUser style={{ fontSize: "18px" }} />

                  <span className="form-labels">Crew</span>
                </NavLink>
              </li>
              <li className="nav-item mb-1">
                <NavLink
                  to="/add_offerings"
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                      isActive ? "btn-danger text-white" : "text-secondary"
                    }`
                  }
                  style={{ borderRadius: "4px", margin: "0 8px" }}
                >
                  {/* <IoHelpCircleOutline style={{ fontSize: "18px" }} /> */}
                  <IoSettingsOutline style={{ fontSize: "18px" }} />

                  <span className="form-labels">Admin Setup</span>
                </NavLink>
              </li>
            </Fragment>
          )}
          {isClinicService && (
            <li className="nav-item mb-1 ">
              <NavLink
                to="/doctors"
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                    isActive ? "btn-danger text-white" : "text-secondary"
                  }`
                }
                style={{ borderRadius: "4px", margin: "0 8px" }}
              >
                <FaUserMd style={{ fontSize: "18px" }} />
                <span className="form-labels">Doctors</span>
              </NavLink>
            </li>
          )}
          {reports?.length > 0 && (
            <li className="nav-item mb-1">
              <NavLink
                to="/reports"
                className={({ isActive }) =>
                  `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                    isActive ? "btn-danger text-white" : "text-secondary"
                  }`
                }
                style={{ borderRadius: "4px", margin: "0 8px" }}
              >
                <MdOutlineReport style={{ fontSize: "18px" }} />

                <span className="form-labels">Reports</span>
              </NavLink>
            </li>
          )}
          {/* <li className="nav-item mb-1">
            <NavLink
              to="/supports"
              className={({ isActive }) =>
                `nav-link d-flex align-items-center gap-2 py-2 px-3 ${
                  isActive ? "btn-danger text-white" : "text-secondary"
                }`
              }
              style={{ borderRadius: "4px", margin: "0 8px" }}
            >
              <IoHelpCircleOutline style={{ fontSize: "18px" }} />
              <span className="form-labels">Support</span>
            </NavLink>
          </li> */}
        </ul>
        <div>
          <img
            src={utilstopAppointmentLogo}
            alt={"vendor Name"}
            style={{ width: "150px", height: "50px" }}
          />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
